import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MeetingEmailTemplateResponse } from '../models/meeting.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface EmailTemplateDrawerOptions {
  templateId?: number;
}

@Injectable({ providedIn: 'root' })
export class MeetingEmailTemplateDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: EmailTemplateDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly saved$$ = new Subject<MeetingEmailTemplateResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: EmailTemplateDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(item: MeetingEmailTemplateResponse): void {
    this.saved$$.next(item);
  }
}
